import { Link } from "react-router-dom";
import { Page } from "@/components/layout/PageHeader";
import { ErrorState } from "@/components/common/States";
import { t } from "@/i18n";

const NotFoundPage = () => (
  <Page testId="not-found-page">
    <ErrorState title={t.errors.notFound} body={t.errors.notFoundBody} action={<Link to="/" className="v-btn-primary v-btn-sm" data-testid="not-found-home">{t.errors.goHome}</Link>} testId="not-found-state" />
  </Page>
);

export default NotFoundPage;
